export function createId(prefix = "id") {
    return `${prefix}_${crypto.randomUUID().slice(0, 8)}`;
}

export function createEmptyHint() {
    return {
        id: createId("hint"),
        text: "",
        code: "",
    };
}

export function createEmptyValidationRule() {
    return {
        id: createId("rule"),
        type: "missing_contains",
        value: "",
        feedback: [""],
    };
}

// STEP = the thing inside parts[].steps[]
export function createEmptyProjectStep() {
    return {
        id: createId("step"),
        text: "",
        answer: "",
        validation: {
            type: "exact", // exact | contains | regex | stdout (you can keep your options)
            value: "",
            rules: [],
        },
        feedback: {
            correct: "",
            incorrect: "",
        },
        hints: [],
    };
}

// PART/SECTION = top-level containers inside project.parts[]
export function createEmptyProjectPart() {
    return {
        id: createId("part"),
        title: "",
        steps: [createEmptyProjectStep()],
    };
}
